export function getTitleWithPopularTitle(item) {
  if (!item.popularTitle) {
    return item.title;
  }

  return `${item.title} “${item.popularTitle}”`;
}
